var GradeLevel = {
	TYPES: {
		"12": {
			paid: false,
			answerLength: 400
		},
		"11": {
			paid: false,
			answerLength: 400
		},
		"10": {
			paid: false,
			answerLength: 400
		},
		"9": {
			paid: false,
			answerLength: 400
		},
		"8": {
			paid: false,
			answerLength: 400
		},
		"7": {
			paid: false,
			answerLength: 370
		},
		"6": {
			paid: false,
			answerLength: 325
		},
		"5": {
			paid: false,
			answerLength: 265
		},
		"4": {
			paid: false,
			answerLength: 235
		},
		"3": {
			paid: false,
			answerLength: 195
		},
		"2": {
			paid: false,
			answerLength: 165
		},
		"1": {
			paid: false,
			answerLength: 140
		},
		"0": {
			paid: false,
			answerLength: 100
		},
		"-1": {
			paid: false,
			answerLength: 100
		},
	},
	
	getName(gradeLevel) {
		switch(gradeLevel.toString()) {
			case "-1":
				return "Pre-Kindergarten"
			case "0":
				return "Kindergarten"
			case "13":
				return "Mixed Grades"
			default:
				return $wr.getOrdinal(parseInt(gradeLevel)) + " Grade";
		}
	},

	getQuizLevel(gradeLevel) {
		gradeLevel = parseInt(gradeLevel);
		if (gradeLevel > 6) {
			return "3";
		} else if (gradeLevel < 4) {
			return "1";
		} else {
			return "2";
		}
	},

	getShortName(gradeLevel) {
		switch(gradeLevel.toString()) {
			case "-1":
				return "PK"
			case "0":
				return "K"
			case "13":
				return "Mixed"
			default:
				return $wr.getOrdinal(parseInt(gradeLevel));
		}
	},

	getRecommendedAnswerLength(gradeLevel) {
		if (GradeLevel.TYPES[gradeLevel]) {
			return GradeLevel.TYPES[gradeLevel].answerLength;
		} else {
			return 300;
		}
	},

	getCharCountFilter(gradeLevel) {
		if (GradeLevel.TYPES[gradeLevel]) {
			var value = GradeLevel.TYPES[gradeLevel].answerLength;
		} else {
			var value = 300;
		}

		value /= 3
		if (value > 120) {
			value = 120
		}

		return value
	},

	isValid(gradeLevel) {
		var asInt = parseInt(gradeLevel);
		return (asInt.toString() == gradeLevel.trim()) && 
			(asInt >= -1) && (asInt <= 13);
	},

	isUnknown(gradeLevel) {
		return gradeLevel == "unknown grade";
	}
}

module.exports = GradeLevel;


// WEBPACK FOOTER //
// ./modules/lib/academic/GradeLevel.js